const infoIcons = {
  department: {
    title: "Moje oddziały",
    body: "Oddziały są podstawowym elementem XLplanner. Wszystkie najważniejsze czynności w aplikacji wykonujesz, przypisując oddział, którego dotyczyć będzie planowana akcja. ",
    button: "Dodaj oddział",
    missing: "Brak oddziałów",
  },
  "outside-department": {
    title: "Magazyny zewnętrzne",
    body: "Magazyny zewnętrzne mogą zostać użyte jako miejsce rozładunku w zleceniach. Nie możesz przypisywać do nich pracowników, ani uzupełniać kalendarzy.",
    button: "Dodaj magazyn zewn.",
    missing: "Brak magazynów zewnętrznych",
  },
  warehouse: {
    title: "Moje magazyny",
    body: "Magazyny są podstawowym elementem XLplanner. Wszystkie najważniejsze czynności w aplikacji wykonujesz, przypisując magazyn, którego dotyczyć będzie planowana akcja. ",
    button: "Dodaj magazyn",
    missing: "Brak magazynów",
  },
  workers: {
    title: "Pracownicy",
    body: "Zapraszaj pracowników do korzystania z aplikacji. Możesz dodać nowych użytkowników, wybierając jedną z trzech roli: Administrator, Kierownik lub Pracownik. Każdy z nich posiada inny zakres uprawnień. Po wysłaniu zaproszenia otrzymają oni mail z danymi do logowania (jeżeli nie posiadają jeszcze konta) lub zostaną dodani do Twojej firmy (jeżeli posiadają już konto XLplanner).",
    button: "Dodaj pracownika",
    for: "Pokaż pracowników dla",
    missing: "Brak pracowników",
  },
  drivers: {
    title: "Kierowcy",
    body: "Kierowcy są niezbędni do składania ofert w zleceniach. W przeciwieństwie do Pracowników, nie posiadają oni konta w aplikacji.",
    button: "Dodaj kierowcę",
    for: "Pokaż kierowców dla",
    missing: "Brak kierowców",
  },
  documents: {
    title: "Dokumenty",
    body: "Dodawaj dokumenty, aby inni użytkownicy mogli zapoznać się z Twoją firmą. Oprócz podstawowych dokumentów, możesz zamieścić dowolne pliki i określić, czy mają być widoczne publicznie czy tylko dla Twojej firmy. ",
    button: "Dodaj dokument",
    missing: "Brak dokumentów",
  },
  cars: {
    title: "Moje auta",
    body: "Dodawaj pojazdy, aby uczestniczyć w zleceniach. Dodaj do auta odpowiedni typ posiadanej licencji. Ustalaj datę końca przeglądu i ubezpieczenia pojazdów, a my wyślemy Ci przypomnienia o upływającym terminie",
    button: "Dodaj pojazd",
  },
  timeWindows: {
    title: "Okna czasowe",
    body: "Okna czasowe służą do rezerwacji okien czasowych podczas awizacji.",
    button: "Wykup okna czasowe",
  },
  abonament: {
    title: "Abonament",
    body: "Abonament umożliwia udział w zleceniach.",
    button: "Wykup abonament",
  },
  warehouseList: {
    title: "Lista magazynów",
    body: "Oto lista magazynów. Znajdziesz tutaj firmy, z którymi możesz dokonywać autoryzacji. Przed wysłaniem prośby o autoryzację zawsze możesz sprawdzić najważniejsze informacje i dokumenty firmy w jej profilu.",
  },
  authorizations: {
    title: "Autoryzacje",
    body: "Tutaj znajdziesz listę wszystkich próśb o autoryzację, które wysłałeś innym firmom. Możesz tu również wycofać swoje prośby.",
  },
  monitaryNote: {
    title: "Awizacje",
    body: "W tej sekcji zobaczysz wszystkie zarezerwowane awizacje, ich status oraz wszystkie szczegółowe informacje. Masz tutaj również dostęp do czatu z magazynem, u którego chcesz przeprowadzić awizację, a także możliwość pobrania dokumentu transportowego. Awizacje możesz rezerwować tylko u zautoryzowanych magazynów.",
    button: "Dodaj awizację",
  },
  postedAuction: {
    title: "Giełda zleceń",
    body: "Znajdują się tutaj zlecenia. Po wykupieniu abonamentu możesz składać oferty, by zdobywać zlecenia.",
  },
  currentAutcions: {
    title: "Uczestniczące Zlecenia",
    body: "Znajdują się tutaj zlecenia, w których aktualnie uczestniczysz",
  },
  assignedAuctions: {
    title: "Przydzielone Zlecenia",
    body: "Znajdują się tutaj zlecenia przydzielone dla Ciebie po przyjęciu Twojej oferty",
  },
  assignedTransports: {
    title: "Przydzielone transporty",
    body: "Są to zlecenia otrzymane od Przewoźnika bezpośrednio, bez konieczności składania ofert.",
    missing: "Brak transportów.",
  },
  canceledTransports: {
    title: "Anulowane / nieotrzymane transporty",
    body: "Są to otrzymane zlecenia, które zostały anulowane lub nieotrzymane.",
  },
  declinedTransports: {
    title: "Nieotrzymane transporty",
    body: "Są to zlecenia pochodzące ze zleceń, których Twój oddział nie otrzymał.",
  },
  additionalPayment: {
    title: "Dodatkowe dopłaty do zleceń",
    body: "Jest to spis wszystkich dopłat, które zostały dołączone do zleconych transportów",
  },
  leasing: {
    title: "Leasing",
    body: "Składaj wnioski leasingowe, które następnie rozpatrzymy. Otrzymasz od nas powiadomienie o decyzji.",
    button: "Złóż wniosek",
    missing: "Brak wniosków",
  },
  factoring: {
    title: "Faktoring",
    body: "Jest to wykaz wszystkich zleceń z przyznanym faktoringiem",
    missing: "Brak aukcji z faktoringiem",
  },
  myWarehouses: {
    title: "Moje magazyny",
    body: "Magazyny są podstawowym elementem XLplanner. Wszystkie najważniejsze czynności w aplikacji wykonujesz, przypisując magazyn, którego dotyczyć będzie planowana akcja. ",
    button: "Dodaj magazyn",
  },
  driversGroups: {
    title: "Grupy pilotów / Utworzone grupy",
    body: "Grupy pilotów możesz wykorzystać podczas wystawia zleceń, jeżeli nie chcesz, aby była dostępna publicznie dla wszystkich użytkowników. Dodając zlecenie, wybierz preferowaną grupę, która będzie odbiorcą. Wówczas tylko Piloci należący do grupy będą mogli zobaczyć aukcję i składać oferty. Do grup możesz dodawać tylko zautoryzowanych Pilotów.",
    button: "Utwórz grupę",
    for: "Pokaż grupy dla",
    missing: "Brak grup dla wybranego oddziału",
  },
  createCalendar: {
    title: "Utwórz kalendarz",
    body: "Wypełnij kalendarz na dany miesiąc, aby Przewoźnicy mogli rezerwować awizacje w magazynie Twojej firmy. Po utworzeniu kalendarza możesz edytować dowolny dzień, dodając, edytując lub usuwając okna czasowe",
  },
  monitaryArchiveDriver: {
    for: "Wybierz oddział",
    missing: "Brak awizacji w archiwum dla wybranego oddziału",
  },
  monitaryArchiveWarehouse: {
    for: "Wybierz magazyn",
    missing: "Brak awizacji w archiwum dla wybranego magazynu",
  },
  auctionsArchive: {
    missing: "Brak aukcji w archiwum",
  },
  auctionsForProducer: {
    missing: "Brak aukcji ",
  },
  authorizationsProducer: {
    title: "Autoryzacje",
    body: "Tutaj znajdziesz listę wszystkich próśb o autoryzację. Możesz je akceptować lub odrzucać.",
  },
  monitaryNotesProducer: {
    title: "Awizacje",
    body: "W tej sekcji zobaczysz wszystkie zarezerwowane awizacje, ich status oraz wszystkie szczegółowe informacje. Masz tutaj również dostęp do czatu z Przewoźnikiem, który zarezerwował awizację w Twoim magazynie, a także możliwość pobrania dokumentu transportowego. Tutaj decydujesz także, czy dany kierowca stawił się o umówionej godzinie.",
  },
  myAuctions: {
    title: "Moje zlecenia",
    body: "Są to wszystkie zlecenia utworzone przez Ciebie. Zlecenia możesz dodawać, edytować i anulować. Tutaj wybierasz także Pilota, któremu przyznasz zlecenie. ",
    button: "Dodaj zlecenie",
  },
  cancelledAuctions: {
    title: "Anulowane zlecenia",
    body: "Jest to lista wszystkich wystawionych ogłoszenia, które zostały anulowane.",
  },
  participants: {
    title: "Wykaz uczestników",
    body: "Jest to wykaz wszystkich Pilotów, którzy biorą udział w zleceniach wystawianych Ciebie.",
    for: "Pokaż uczestników dla",
    missing: "Brak uczestników",
  },
  wallet: {
    button: "Doładuj okna",
    buttonSub: "Wykup abonament",
  },
  invoiceList: {
    missing: "Brak wystawionych faktur.",
  },
  monthlyInvoices: {
    title: "Faktury miesięczne",
    body: "W tym miejscu znajdziesz zestawienie wszystkich płatności w danym miesiącu. Zestawienie jest generowane na początku następnego miesiąca.",
  },
};
export default infoIcons;
